import TagManager from 'react-gtm-module';

import {
  GTM_ID,
} from '../constants/constants';

const initializeTagManager = () => {
  const tagManagerArgs = {
    gtmId: GTM_ID,
  };

  TagManager.initialize(tagManagerArgs);
};

export default initializeTagManager;
